<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-shiba">
      <div class="px-3 col-3 p-0">
        <div class="heading-shiba">{{ $t('result.round') }}</div>
        <div class="text-subhead-shiba">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-shiba">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-shiba">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-shiba">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-shiba"> {{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-shiba">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-shiba">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-shiba pt-3">
      <div class="text-games-shiba">{{ 'Shiba Mogul' }}</div>
      <div class="text-subgame-shiba">{{ $t('shiba.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="result.bonusWin.length > 0" class="fas fa-caret-left arrow-side-shiba" @click="delCount()"></i>
        </div>
        <div class="table-shiba container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="i">
                  <img class="icon-symbol" :src="require(`../../assets/resultGame/shiba/symbol_${col}.png`)" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-shiba" @click="addCount()"></i>
        </div>
      </div>
      <div v-if="result.winLines.length > 0 && bonusGames == false" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-if="result.winLines.length > 0 && bonusGames == false" class="col-12 justify-content-center d-flex flex-row mt-3">
        <div class="bet-box-shiba p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in symbolsDetail" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-shiba item">
                <div class="d-flex justify-content-start bet-wrapper-shiba item">
                  <img class="icon-detail-shiba" :src="require(`../../assets/resultGame/shiba/symbol_${detail}.png`)"
                    alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 red">{{ `${countSymbol[index]} ` + $t('result.kind') }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1 text-black">{{ currency }} {{ result.winInRows[index] | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="result.bonusWin.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <div class="col-2"></div>
        <hr class="line">
        <div class="text-games-shiba align-items-center d-flex px-3">{{ $t('result.bonus') }}</div>
        <hr class="line">
        <div class="col-2"></div>
      </div>
      <div v-if="result.bonusWin.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <div class="bonus-box p-2 px-3">
          <div class="bet-warpper">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-shiba item">
                <div class="d-flex justify-content-start bet-wrapper-shiba item">
                  <img class="icon-bonus-shiba"
                    :src="require(`../../assets/resultGame/shiba/bonus_symbol_${result.bonusWin.at(-1).index}.png`)"
                    alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 red">{{ `Got Bonus ${result.bonusWin.at(-1).index}` }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1 text-black">{{ currency }} {{ result.bonusWin.at(-1).bonusWin | currencyFormatter }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-shiba',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 4, 7, 10, 13,],
        [2, 5, 8, 11, 14,],
        [3, 6, 9, 12, 15,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      result: this.data,
      count: this.data.count,
      countSymbol: [],
      symbolsDetail: [],
      bonusGames: false,
      symbolsBonus: [],
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-shiba')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.result = result;
      this.isEndRound = result.isEndRound;
      this.winnings = result.winnings;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.bonusGames = result.state === "SPIN" ? false : true;
      this.symbolsDetail = [];
      this.table[0][0] = result.numbers[0]
      this.table[1][0] = result.numbers[1]
      this.table[2][0] = result.numbers[2]
      this.table[0][1] = result.numbers[3]
      this.table[1][1] = result.numbers[4]
      this.table[2][1] = result.numbers[5]
      this.table[0][2] = result.numbers[6]
      this.table[1][2] = result.numbers[7]
      this.table[2][2] = result.numbers[8]
      this.table[0][3] = result.numbers[9]
      this.table[1][3] = result.numbers[10]
      this.table[2][3] = result.numbers[11]
      this.table[0][4] = result.numbers[12]
      this.table[1][4] = result.numbers[13]
      this.table[2][4] = result.numbers[14]

      let number = result.numbers
      let winline = result.winLines
      let line = this.data.game.config.betLines

      let sum = [...winline.map(() => (
        []
      ))]

      winline.forEach((v, i) => {
        line[v].forEach((w) => {
          sum[i].push(number[w])
        })
      })

      sum.forEach((v) => {
        let first = v[0];
        let count = 0;
        v.forEach((sym, i) => {
          if ((sym === first || sym === 7) && i === count) count++;
          else return count
        })
        this.countSymbol.push(count)
        this.symbolsDetail.push((v)[0])
      })
      this.symbolsBonus = result.bonusWin

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}
</script>

<style scoped>
.icon-detail-shiba {
  width: 85px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-shiba {
  width: 75px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-shiba {
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-shiba {
  background: #f4c06d;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box {
  background: #f4c06d;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-shiba .item {
  color: #fff;
  background: #f4c06d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #000;
}

.bet-box-shiba .bet-wrapper-shiba:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-shiba,
.result-wrapper {
  font-size: 35px;
}

.header-shiba {
  background: #f4c06d;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-shiba>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-shiba {
  color: #000;
  font-weight: bold;
  text-align: center;
}

.content-result-shiba {
  background: #252525;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-shiba {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-shiba {
  color: #fff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-shiba {
  font-size: px;
  color: #000;
  text-align: center;
}

.text-subgame-shiba {
  font-size: 20px;
  color: #fb820b;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-shiba {
  min-width: 600px;
  max-width: auto;
}

.table-shiba {
  background: url('~@/assets/resultGame/shiba/board.png') no-repeat;
  background-size: 570px 440px;
  width: 570px;
  height: 440px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;

}

@media screen and (max-width: 1030px) {
  .table-shiba {
    background-size: 500px 400px;
    width: 500px;
    height: 380px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-shiba {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-shiba,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-shiba,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-shiba {
    font-size: 18px;
  }

  .table-shiba {
    background-size: 470px 420px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
    /* padding-bottom: 35px; */
  }

  .text-subhead-shiba {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-shiba {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header-shiba>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-shiba {
    font-size: 12px;
  }

  .table-shiba {
    background-size: 250px 180px;
    width: 250px;
    height: 180px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-shiba {
    font-size: 14px;
  }

  .bet-box-shiba {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-shiba,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-shiba {
    width: 45px;
    height: 55px;
  }

  .icon-bonus-shiba {
    width: 40px;
    height: 60px;
  }
}

.text-black {
  color: #000;
}
</style>